import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    apps() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/auth/modules/");
                resolve(data);
            } catch (error) {
                console.log(error);
                errorHandler(error, reject)
            }
        });
    },
    listtodo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'taskdetail', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/tasktodo${str}`;
                const { data } = await axios.get(url);
                // resolve(data);
                const { meta, list } = data;

                resolve({list,total:meta.total});
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    listtodoHistory(objhistory) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','taskdetail', 'tgl1', 'tgl2', 'actiontake', 'finalapproval', 'tglaction1', 'tglaction2'];
                let str = '';
                for (const key in objhistory) {
                    if (keys.indexOf(key) >= 0 && objhistory[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(objhistory[key]);
                    }
                }
                const url = `/tasktodo/historylist${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                resolve({list,totalhistory:meta.total});
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },


};